import { render, staticRenderFns } from "./BannerPWA.vue?vue&type=template&id=2e938fe8&scoped=true&"
import script from "./BannerPWA.vue?vue&type=script&lang=ts&"
export * from "./BannerPWA.vue?vue&type=script&lang=ts&"
import style0 from "./BannerPWA.vue?vue&type=style&index=0&id=2e938fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e938fe8",
  null
  
)

export default component.exports